// extracted by mini-css-extract-plugin
module.exports = {"container":"Permits_container__s58m2","root":"Permits_root__1HHXU"};